import { render, staticRenderFns } from "./ScoreDas28.vue?vue&type=template&id=4f3af206"
import script from "./ScoreDas28.vue?vue&type=script&lang=js"
export * from "./ScoreDas28.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports